import { actionSet } from 'action/utils'

import { GET_PAGES } from 'actionTypes'

export const getPages = (counter, metadata = {}, action = GET_PAGES) => {
  const pagination =
    typeof counter === 'object' && counter !== null ? counter : metadata

  return {
    count: pagination.totalCount,
    current: pagination.page,
    pages: pagination.pageCount,
    type: action,
    counter,
  }
}

export const callWithPagination = (
  data,
  dispatch,
  actionType,
  counter,
  page = 1,
  size = 10
) => {
  const qtt = data.length
  const qtd = size
  let pages = Math.floor(qtt / qtd)
  if (qtt % qtd > 0) {
    pages += 1
  }
  const begin = (page - 1) * qtd
  const end = page * qtd
  data = data.slice(begin, end)
  dispatch(actionSet(actionType, data))

  return {
    type: GET_PAGES,
    pages,
    current: page,
    count: qtt,
    counter,
  }
}

export const callKardexWithPagination = (
  data,
  dispatch,
  actionType,
  counter,
  current = 1
) => {
  const { kardexPojoList } = data

  const count = kardexPojoList.length
  const qtd = 9999
  const pages = Math.ceil(count / qtd)

  const begin = (current - 1) * qtd
  const end = current * qtd

  const kardexPojoListSliced = kardexPojoList.slice(begin, end)
  const contentPaginated = { ...data, kardexPojoList: kardexPojoListSliced }

  dispatch(actionSet(actionType, contentPaginated))

  return {
    type: GET_PAGES,
    pages,
    current,
    count,
    counter,
    contentPaginated,
  }
}

export const getPaginationUrl = (url, page = 1, size = 10) =>
  `${url}?page=${page}&size=${size}`
